import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BarcodeScanner } from '@capacitor-mlkit/barcode-scanning';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'app-search-screen',
    templateUrl: './search-screen.component.html',
    styleUrls: ['./search-screen.component.css'],
    standalone: false
})

export class SearchScreenComponent implements OnInit {

  search: string = '';
  searchType: string = 'upc';
  searchTypes: string[] = ['upc'];
  platform: string = 'web';

  constructor(private router: Router) { }

  async scanCode(){

    if(Capacitor.getPlatform() === 'web'){
      return;
    }

    const { barcodes } = await BarcodeScanner.scan();

    if(barcodes.length > 0){
      this.search = barcodes[0].rawValue;
      this.searchType = this.searchTypes[0];
      this.searchProduct();
    }
  }

  searchProduct(){
    this.router.navigate(['/product-display'], { queryParams: { search: this.search, search_type: this.searchType } });

  }

  ngOnInit(): void {  
    this.platform = Capacitor.getPlatform();
  }
}
